import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';
import { PositionSettingType } from 'types/store';

export const signaturesPositionOptions: SettingsRadioItem<PositionSettingType>[] = [
  {
    value: 'flex-start',
    label: 'Слева',
  },
  {
    value: 'center',
    label: 'По центру',
  },
  {
    value: 'flex-end',
    label: 'Справа',
  },
];

export const signaturesPositionVerticalOptions: SettingsRadioItem<PositionSettingType>[] = [
  {
    value: 'flex-start',
    label: 'Сверху',
  },
  {
    value: 'center',
    label: 'По центру',
  },
  {
    value: 'flex-end',
    label: 'Снизу',
  },
];

export const signaturesLocationOptions: SettingsRadioItem<PositionSettingType>[] = [
  {
    value: 'flex-start',
    label: 'Внизу',
  },
  {
    value: 'center',
    label: 'По центру',
  },
  {
    value: 'flex-end',
    label: 'Вверху',
  },
];
